import { render, staticRenderFns } from "./TurnaroundAdd.vue?vue&type=template&id=f1c46bc2"
import script from "./TurnaroundAdd.vue?vue&type=script&lang=js"
export * from "./TurnaroundAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports